function Secrets() {
    return (
        <div>
            <h1>You have reached the secret page</h1>
            <p>Here are some secrets:</p>
            <h1>time join alone narrow coyote next blush museum glance soup huge remind kick split degree genuine erosion federal canoe review thing miss song motion gather</h1>
        </div>
    );
}
export default Secrets;